export const MERGE_FIELD_VALIDATION_OPTIONS = {
  error_if_required: 'error_if_required',
  blank: 'blank',
  default_to_unknown: 'default_to_unknown',
} as const;

export const BELOW_THRESHOLD_ACTION_OPTIONS = {
  continue_down_yes_path: 'continue_down_yes_path',
  continue_down_no_path: 'continue_down_no_path',
  fail_the_step: 'fail_the_step',
} as const;

export const DEVELOPER_DOCS_URL = 'https://developer.kizen.com/';
